<template>
  <div class="welfare-notice">
    <div class="welfare-notice__icon">
      <vb-icon
        name="clock"
        :color="sass('livegift-blue-dark')"
        :size="20"
      />
    </div>

    <div class="welfare-notice__content">
      <p class="welfare-notice__title">Non lasciare scadere il tuo credito welfare.</p>
      <p class="welfare-notice__text">
        Il credito welfare inutilizzato decade a fine anno. Con la Gift Card lo trasformi subito in
        valore concreto, spendibile con calma nei prossimi {{ validity_months }} mesi su tutte le strutture VadoBay.
      </p>
    </div>
  </div>
</template>

<script>
  import { VALIDITY_MONTHS } from '@livegift/resources';

  export default {
    name: 'welfare-notice',

    computed: {
      validity_months: () => VALIDITY_MONTHS,
    },
  };
</script>

<style lang="scss" scoped>

  // l'azzurro chiaro dell'icona e il bordo non hanno un token nel progetto,
  // quindi restano espliciti qui
  .welfare-notice {
    display: flex;
    align-items: flex-start;
    padding: $grid-gutter-20;
    margin-top: $grid-gutter-width;
    background: $selected;
    border: $border-width solid #e2eaf7;
    border-radius: $border-radius-lg * 3;

    &__icon {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      margin-right: $grid-gutter-width / 2;
      background-color: #deecff;
      border-radius: 50%;
    }

    &__title {
      margin: 0;
      font-size: $font-size-md;
      font-weight: $vb-font-weight-semibold;
      color: $livegift-blue-dark;
    }

    &__text {
      margin: 4px 0 0;
      font-size: $font-size-sm;
      color: $gray-900;
    }
  }
</style>